import * as React from 'react'
import cx from 'classnames'
import { observer } from 'mobx-react'
import MilestoneItem from './MilestoneItem'
import MilestonesViewModel from '../MilestonesViewModel'
import styles from './MilestoneSwitcherContent.sass'

interface Props {
  vm: MilestonesViewModel
  isCardLayout?: boolean
}

export default observer(function MilestoneSwitcherContent({
  vm,
  isCardLayout,
}: Props) {
  return (
    <div className={cx(styles.root)}>
      <div className={styles.header}>
        <p className={styles.title}>
          Milestones{' '}
          <span className={styles.progress}>
            ({vm.completedMilestones.length} of {vm.milestones.length}{' '}
            completed)
          </span>
        </p>
      </div>
      <div className={styles.list}>
        {vm.milestones.map((milestone, i) => (
          <MilestoneItem
            key={milestone.id}
            milestone={milestone}
            vm={vm}
            isLast={i === vm.milestones.length - 1}
            isCardLayout={isCardLayout}
          />
        ))}
      </div>
    </div>
  )
})
